import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import {
  COLOR_DARK_PURPLE,
  COLOR_WHITE,
  COLOR_ORANGE,
  COLOR_BLUE,
  COLOR_LIGHT_PURPLE,
} from '../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';
import checkImg from '../../assets/img/svg/check.svg';
import Tooltip from '../ui/tooltip';

export default styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: row wrap;
  justify-content: space-between;
  height: auto;
  width: 100%;
  padding: 0 15px;
  max-width: 1270px;
  margin: 0 auto;

  .loading-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }

  .type-switch-wrap {
    width: 100%;
    min-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 64px 0;

    .inside-wrap {
      display: flex;
      width: 1120px;
      height: 50px;
      border-radius: 12px;
      box-shadow: inset 0 0 0 1px ${rgba(COLOR_ORANGE, 1)};

      &.full-width {
        width: 100%;
      }

      button {
        height: 50px;
        padding: 0 0 4px 0;
        background: none;
        width: 33.333%;
        border-radius: 12px;
        border: none;
        font-size: 18px;
        font-weight: bold;
        color: ${COLOR_ORANGE};
        &.active {
          color: ${COLOR_WHITE};
          background-image: linear-gradient(to left, #fab535, #f7931e);
        }
      }
    }
  }

  .left-wrap {
    padding-right: 100px;
    width: 33.3333%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    &.text-justify {
      text-align: justify;

      h1 {
        text-align: center;
      }

      .focus-button {
        margin: 24px auto 0 auto;
      }
    }

    .subtext {
      padding-top: 16px;
    }
    .focus-button {
      display: block;
      margin-top: 24px;
    }
  }

  .overview-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;

    .subtext {
      padding: 16px 0 24px 0;
    }

    .mid-wrap {
      min-width: 350px;

      .mid-wrap--card {
        &:last-child {
          margin-bottom: 0px;
        }
      }

      @media (max-width: ${BP_TABLET_MAX}px) {
        min-width: auto;

        .mid-wrap--card {
          &:last-child {
            margin-bottom: 80px;
          }
        }
      }

      @media (max-width: ${BP_MOBILE_MAX}px) {
        min-width: auto;
      }
    }
  }

  .mid-wrap {
    margin-bottom: 80px;

    @media (max-width: ${BP_TABLET_MAX}px) {
      margin-bottom: 0px;
    }
  }

  .withdrawal-wrap {
    max-width: 350px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 auto 80px auto;
    span {
      padding: 16px 0;
    }
    button {
      width: 100%;
    }
    .subtext {
      padding-bottom: 24px;
    }
  }
  .mid-wrap {
    width: 33.3333%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    &--card {
      margin-bottom: 24px;
      border-radius: 12px;
      background: ${COLOR_LIGHT_PURPLE};
      padding: 8px 8px 16px 16px;
      &.disabled {
        background: ${rgba(COLOR_LIGHT_PURPLE, 0.4)};
      }
      &__top {
        display: flex;
        justify-content: space-between;
        &.disabled {
          p {
            opacity: 0.4;
          }
        }
      }
      &__bottom {
        padding-top: 16px;
        padding-right: 8px;
        overflow: hidden;

        &.padded {
          padding-top: 20px;
        }
        .wrap {
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .input-label {
          order: 2;
          position: relative;
          margin-bottom: 0px;
          font-size: 29px;
          padding-right: 20px;
          font-weight: bold;
          color: ${COLOR_WHITE};
        }

        .invest-amount-input {
          order: 1;
          font-size: 29px;
          font-weight: bold;
          padding-right: 8px;
          width: calc(100% - 20px);
          background: none;
          color: ${COLOR_WHITE};
          border: none;
          text-align: right;

          &.orange {
            color: #f0ac00;
          }
          &::placeholder {
            color: ${rgba(COLOR_WHITE, 0.2)};
          }
          &:active,
          &:focus {
            outline: none;
            box-shadow: none;
          }
        }
        &--stats {
          display: flex;
          justify-content: space-between;
        }
        &.disabled {
          pointer-events: none;
          opacity: 0.4;
        }
      }

      &.hoverable:hover {
        cursor: pointer;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        p {
          color: ${COLOR_WHITE};
        }
      }
    }
    .reinvest-approve {
      display: flex;
      align-items: center;
      input {
        margin-right: 16px;
        -webkit-appearance: none;
        box-shadow: none;

        &[type='checkbox'] {
          width: 24px;
          height: 24px;
          cursor: pointer;
          background: none;
          border-radius: 8px;
          border: none;
          &:focus {
            box-shadow: none !important;
            outline: none !important;
            border: none !important;
          }
        }
        &[type='checkbox']:before {
          position: relative;
          display: block;
          width: 24px;
          height: 24px;
          border: none;
          content: '';
          background: none;
          border-radius: 8px;
        }

        &[type='checkbox']:after {
          position: relative;
          display: block;
          left: 0px;
          top: -24px;
          width: 24px;
          height: 24px;
          border-style: none;
          border-color: none;
          content: '';
          background-color: ${COLOR_DARK_PURPLE};
          border-radius: 8px;
          border: 1px solid #403e4f;
          background-repeat: no-repeat;
          background-position: center;
        }

        &[type='checkbox']:checked:after {
          background-image: url(${checkImg});
          background-color: ${COLOR_ORANGE};
        }
      }
    }
  }
  .right-wrap {
    width: 33.3333%;
    padding-left: 100px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    text-align: center;

    .interest-wrap {
      .subtext {
        padding-top: 14px;
        text-align: left;
      }
    }

    .circle-progress-wrap {
      max-width: 164px;
      min-width: 164px;
      height: 164px;
      margin-bottom: 16px;

      border-radius: 300px;
      box-shadow: 0px 0px 12px 2px ${rgba(COLOR_BLUE, 0.2)},
        inset 0px 0px 12px 2px ${rgba(COLOR_BLUE, 0.2)};

      &--text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        span,
        div {
          font-size: 37px;
          font-weight: 300;
          color: ${rgba(COLOR_WHITE, 0.6)};
        }
        div {
          margin-left: 0px;
          text-shadow: 0 2px 10px ${COLOR_DARK_PURPLE};
          margin-top: 0px;
          font-size: 48px;
          color: ${COLOR_WHITE};
          font-weight: bold;
        }
        span {
          margin-top: -10px;
        }
      }
      .CircularProgressbar {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        &-path {
          stroke: ${COLOR_BLUE};
        }
        &-trail {
          stroke: ${COLOR_DARK_PURPLE};
        }
      }
    }

    .subtext {
      padding-top: 16px;
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    flex-direction: column;
    max-width: 560px;
    margin: 0 auto;

    .type-switch-wrap {
      width: 100%;
      min-width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 0 34px 0;

      .inside-wrap {
        display: flex;
        flex-direction: column;
        height: auto;
        width: 100%;
        border-radius: 12px;
        box-shadow: inset 0 0 0 1px ${rgba(COLOR_ORANGE, 1)};
        button {
          height: 50px;
          padding: 0 0 4px 0;
          background: none;
          width: 100%;
          border-radius: 12px;
          border: none;
          font-size: 18px;
          font-weight: bold;
          color: ${COLOR_ORANGE};
          &.active {
            color: ${COLOR_WHITE};
            background-image: linear-gradient(to left, #fab535, #f7931e);
          }
        }
      }
    }

    .left-wrap {
      width: 100%;
      padding-right: 0px;
      padding-bottom: 24px;
      text-align: center;
      .focus-button {
        display: block;
        margin: 24px auto 0 auto;
      }
    }
    .mid-wrap {
      width: 100%;
    }
    .right-wrap {
      width: 100%;
      padding-left: 0px;
      padding-top: 24px;
      text-align: center;
      margin-bottom: 80px;
      .interest-wrap {
        h2 {
          margin: 0 auto;
        }
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    padding: 0 16px;

    .left-wrap {
      text-align: left;
      .focus-button {
        display: block;
        width: 100%;
      }
    }

    .right-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;

      .circle-progress-wrap {
        margin-left: 0px;
        width: 120px;
        height: 120px;
        max-width: 120px;
        min-width: 120px;
        margin-bottom: 0px;
        &--text {
          div {
            font-size: 36px;
          }
          span {
            margin-top: -10px;
            font-size: 24px;
          }
        }
      }
      .interest-wrap {
        padding-left: 20px;
        max-width: calc(100% - 120px);
        text-align: left;
        h2 {
          margin: 0;
        }
      }
    }
  }
`;

export const HintSC = styled.span`
  cursor: pointer;
  width: 16px;
  height: 16px;
  background-image: linear-gradient(to left, #fab535, #f7931e);
  color: ${COLOR_WHITE};
  margin-top: 5px;
  margin-left: 8px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
`;

export const ExtendendWrapSC = styled.div`
  overflow: hidden;
  &.active {
    background: ${COLOR_DARK_PURPLE};
    padding-bottom: 70px;
    height: auto;
    transition: all 0.5s;
  }
  height: 0px;

  .approve-wrap {
    max-width: 400px;
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    a {
      color: ${COLOR_WHITE};
      font-weight: bold;
      &:hover {
        text-decoration: unredline;
        color: ${COLOR_WHITE};
      }
    }
    input {
      margin-right: 16px;
      -webkit-appearance: none;
      box-shadow: none;

      &[type='checkbox'] {
        width: 24px;
        height: 24px;
        cursor: pointer;
        background: none;
        border-radius: 8px;
        border: none;
        &:focus {
          box-shadow: none !important;
          outline: none !important;
          border: none !important;
        }
      }
      &[type='checkbox']:before {
        position: relative;
        display: block;
        width: 24px;
        height: 24px;
        border: none;
        content: '';
        background: none;
        border-radius: 8px;
      }

      &[type='checkbox']:after {
        position: relative;
        display: block;
        left: 0px;
        top: -24px;
        width: 24px;
        height: 24px;
        border-style: none;
        border-color: none;
        content: '';
        background-color: ${COLOR_DARK_PURPLE};
        border-radius: 8px;
        border: 1px solid #403e4f;
        background-repeat: no-repeat;
        background-position: center;
      }

      &[type='checkbox']:checked:after {
        background-image: url(${checkImg});
        background-color: ${COLOR_ORANGE};
      }
    }
  }

  .extended-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: auto;
    width: 100%;
    padding: 30px 15px 0 15px;
    max-width: 1270px;
    margin: 0 auto;
    .text-wrap {
      max-width: 70%;
    }
    .buttons-wrap {
      min-width: 400px;
      button {
        min-width: 183px;
      }
      .cancel-button {
        margin-right: 23px;
        text-transform: inherit;
        font-size: 18px;
        padding: 11px 40px 10px 40px;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    &.active {
      padding-bottom: 40px;
    }
    .approve-wrap {
      margin: 0 auto;
      text-align: left;
    }
    .extended-wrap {
      flex-direction: column;
      max-width: 560px;
      margin: 0 auto;
      .text-wrap {
        text-align: center;
        max-width: 100%;
        width: 100%;
      }
      .buttons-wrap {
        margin-top: 20px;
        text-align: center;
        max-width: 100%;
        width: 100%;
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    &.active {
      padding-bottom: 30px;
    }
    .extended-wrap {
      max-width: 100%;
      .buttons-wrap {
        display: flex;
        flex-direction: column;
        min-width: 100%;
        button {
          min-width: 100%;
        }
        .cancel-button {
          margin-right: 0px;
          margin-bottom: 20px;
        }
      }
    }
  }
`;

const hoverStyle = css`
  svg {
    circle {
      fill: ${COLOR_ORANGE};
    }
    text {
      fill: #434162;
    }
  }
`;

export const TooltipSC = styled(Tooltip)`
  opacity: 1;

  &.tooltip-icon {
    svg {
      circle {
        stroke: ${COLOR_ORANGE};
      }
      text {
        fill: ${COLOR_ORANGE};
      }
    }

    @media (hover: hover) {
      /* when supported */
      &:hover {
        ${hoverStyle}
      }
    }
    &.tooltip-visible {
      ${hoverStyle}
    }
  }
`;
